import React, { Component } from "react";
import { ApolloProvider } from 'react-apollo'
import { ApolloProvider as ApolloHooksProvider } from '@apollo/react-hooks'
import { ApolloClient } from 'apollo-client'
import { createUploadLink } from 'apollo-upload-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import PropTypes from 'prop-types'
import Pane from './Pane'
import { authLink } from '../shared/ApolloClient'
import DocumentsConfigProvider from './contexts/DocumentsConfigContext'
import SnackbarProvider from './contexts/SnackbarContext'

const uploadLink = createUploadLink({ uri: '/api/graphs' })

export const client = new ApolloClient({
  link: authLink.concat(uploadLink),
  cache: new InMemoryCache({
    dataIdFromObject: obj => {
      const { __typename, rid, value, label, id } = obj;

      if (__typename === 'SelectorOption') {
        return `${__typename}${value}${label}`;
      } else {
        return id || `${__typename}${rid || ''}`;
      }
    }
  })
})

class Layout extends Component {
  state = {
    documentActive: false
  }

  componentDidMount() {
    const { menuItems, handleActive } = this;

    menuItems.map((menuItem) => {
      menuItem.addEventListener("click", handleActive);
    });
  }

  componentWillUnmount() {
    const { menuItems, handleActive } = this;

    menuItems.map((menuItem) => {
      menuItem.removeEventListener("click", handleActive);
    });
  }

  handleActive = () => {
    this.setState({ documentActive: true });
  }

  get menuItems() {
    const menuItems = document
      ?.getElementById("admin_tabs")
      ?.querySelectorAll("[data-toggle]");

    if (!!menuItems) {
      return [...menuItems];
    }

    return [];
  }

  render() {
    const {
      props: {
        percentage,
        entityId,
        handedOff,
        newDocs,
        resourceType,
        loanId,
        superUser,
        canComment,
        bankAdmin,
        customerService,
        idx,
        disableUnderwriter,
       },
      state: { documentActive }
    } = this;

    if (!documentActive) return null;

    return (
      <DocumentsConfigProvider {...this.props}>
        <ApolloHooksProvider client={client}>
          <ApolloProvider client={client}>
            <SnackbarProvider>
              <Pane
                resourceType={resourceType}
                entityId={entityId}
                percentage={percentage}
                handedOff={handedOff}
                newDocs={newDocs}
                loanId={loanId}
                superUser={superUser}
                canComment={canComment}
                bankAdmin={bankAdmin}
                customerService={customerService}
                idx={idx}
                client={client}
                disableUnderwriter={disableUnderwriter}
              />
            </SnackbarProvider>
          </ApolloProvider>
        </ApolloHooksProvider>
      </DocumentsConfigProvider>
    );
  }
}

Layout.propTypes = {
  loanId: PropTypes.number.isRequired,
  resourceType: PropTypes.string.isRequired,
  handedOff: PropTypes.bool.isRequired,
  percentage: PropTypes.number,
  superUser: PropTypes.bool,
  hideArchivedFiles: PropTypes.bool,
}

export { Layout };
export default Layout;
